// proj4
import proj4 from 'proj4';

// turf
import { lineDistance } from '@turf/turf';


/**
 * @param coords - An array with 2 elements which represent lon,lat.
 */
 const convertCoords = (coords: number[]) => {
    const utmZone = Math.ceil((coords[0] + 180) / 6);

    let epsgStart = 326; // 326 is for north
    if (coords[1] < 0) {
        epsgStart = 327; // 327 is for south
    }

    const epsg = `EPSG:${epsgStart}${utmZone}`;

    return {
        epsg: epsg,
        coordinates: proj4('EPSG:4326', epsg, coords),
    };
};

const calculateDistance = (v1: number[], v2: number[]): number => {
    const dx = v2[0] - v1[0];
    const dy = v2[1] - v1[1];
    return Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
};


export const getLineLength = (lineFeature, isMeters=true) => {
    let currentLineLength = 0;
    for (let i = 0; i < lineFeature.geometry.coordinates.length - 1; i++) {
        let v1 = convertCoords(lineFeature.geometry.coordinates[i]);
        let v2 = convertCoords(lineFeature.geometry.coordinates[i + 1]);
        if (v1.epsg !== v2.epsg) {
            currentLineLength = lineDistance(lineFeature) * 1000;
            break;
        } else {
            currentLineLength = calculateDistance(
                v1.coordinates,
                v2.coordinates,
            );
        }
    }
    return Math.round(currentLineLength * 100 * (isMeters ? 1 : 1.09361)) / 100
};

export const getPolygonEdgeLabelFeature = (geojson, point_1_idx, point_2_idx, isMeters) => {
    let label_x_pos, label_y_pos;
    label_x_pos = (geojson.geometry.coordinates[0][point_1_idx][0]+geojson.geometry.coordinates[0][point_2_idx][0])/2;
    label_y_pos = (geojson.geometry.coordinates[0][point_1_idx][1]+geojson.geometry.coordinates[0][point_2_idx][1])/2;

    const currentLine = {
        type: 'Feature',
        properties: {
            meta: 'currentLine'
        },
        geometry: {
            type: 'LineString',
            coordinates: [
                geojson.geometry.coordinates[0][point_1_idx],
                geojson.geometry.coordinates[0][point_2_idx]
            ],
        },
    };    

    const currentLineLabel = {
        type: 'Feature',
        properties: {
            meta: 'linelabel',
            active: geojson.properties.active,
            totalMeasurementLabel: `${getLineLength(currentLine, isMeters)} ${isMeters ? 'm' : 'yd'}`,
            markerOpacity: 0
        },
        geometry: {
            type: 'Point',
            coordinates: [label_x_pos,label_y_pos],
        },
    }

    return currentLineLabel;
}

export const getLineEdgeLabelFeature = (geojson, point_1_idx, point_2_idx, isMeters, totalMeasurement:any = undefined) => {
    let label_x_pos, label_y_pos;
    label_x_pos = (geojson.geometry.coordinates[point_1_idx][0]+geojson.geometry.coordinates[point_2_idx][0])/2;
    label_y_pos = (geojson.geometry.coordinates[point_1_idx][1]+geojson.geometry.coordinates[point_2_idx][1])/2;

    const currentLine = {
        type: 'Feature',
        properties: {
            meta: 'currentLine'
        },
        geometry: {
            type: 'LineString',
            coordinates: [
                geojson.geometry.coordinates[point_1_idx],
                geojson.geometry.coordinates[point_2_idx]
            ],
        },
    };    

    const lineLength = getLineLength(currentLine, isMeters);

    const currentLineLabel = {
        type: 'Feature',
        properties: {
            meta: 'linelabel',
            active: geojson.properties.active,
            totalMeasurementLabel: `${lineLength} ${isMeters ? 'm' : 'yd'}`,
            markerOpacity: 0
        },
        geometry: {
            type: 'Point',
            coordinates: [label_x_pos,label_y_pos],
        },
    }

    if(totalMeasurement){
        totalMeasurement.value = totalMeasurement.value + lineLength;
    }

    return currentLineLabel;
}